
import { ADDRESS_PROOF_TYPE, ADDRESS_PROOF_TYPE_FEEBASED ,ADDRESS_PROOF_TYPE_SMART } from 'src/app/constant/string';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, DoCheck, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { getAddressElements } from './address-form-element';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { DFormHelpers, IDFormControl } from '../d-form/d-form.helpers';
import { IAddressOptions } from '../types';
import { SharedService } from 'projects/services/src/app/shared/shared.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

const FORCED_REQUIREDS_FIELDS = {
	tehsil: false,
	city: false,
	parliamentaryConstituency: false,
}
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-address-form',
	templateUrl: './address-form.component.html',
	styleUrls: ['./address-form.component.css']
})
export class AddressFormComponent implements OnInit, DoCheck ,OnChanges{
	@Input() residential=false;

	@Input() address = '';
	@Input() validationCheck = false;
	@Output() addressChange = new EventEmitter();
	@Input() landmark = '';
	@Output() landmarkChange = new EventEmitter();
	@Input() pincode = '';
	@Output() pincodeChange = new EventEmitter();
	@Input() state: any;
	@Output() stateChange = new EventEmitter();
	@Input() district = '';
	@Output() districtChange = new EventEmitter();
	@Input() tehsil = '';
	@Output() tehsilChange = new EventEmitter();
	@Input() city = '';
	@Input() cityTextBox = '';
	@Input() parliamentaryConstituency = '';
	@Output() parliamentaryChange = new EventEmitter();
	@Input() addressProof = '';
	@Input() addressProofRequired = false;
	@Input() addressProofTypeRequired = false;
	@Input() addressProofType = '';
	@Output() addressProofTypeChange = new EventEmitter();
	@Input() nameRequired = false;
	@Output() addressProofChange = new EventEmitter();
	@Output() completeAddressChange = new EventEmitter();
	@Input() disable: boolean;
	@Input() valid: boolean;
	@Output() validChange = new EventEmitter();
	@Input() defaultAddress: any = {};
	@Input() label: string;
	@Input() subLabel: string;
	@Input() completeAddress: any = {};
	addressFormControl: IDFormControl;
	@Input() fnBuffer = [];
	@Output() control = new EventEmitter();
	@Input() tccaf = false;
	@Input() isNorthEastStatesOnly: boolean;
	@Input() tcState: string;
	parliamentary: any = false;
	defaultOptions: IAddressOptions = {
		isPlane: true,
		addressProofRequired: false,
		addressProofTypeRequired: false,
		nameRequired: false,
		labelDiv: 2,
		inputDiv: 10,
		fields: {
			name: false,
			detail: true,
			landmark: true,
			pincode: true,
			state: true,
			cityTextBox: false,
			district: true,
			tehsil: true,
			city: true,
			parliamentaryConstituency: true,
			addressProof: false,
			addressProofType: false,
			geoLocation: true,
		},
		required: {
			name: true,
			detail: true,
			cityTextBox: true,
			landmark: true,
			pincode: true,
			state: true,
			district: true,
			tehsil: true,
			city: true,
			parliamentaryConstituency: true,
			addressProofType: true,
			addressProof: true,
			geoLocation: true
		}
	};
	@Input() options: IAddressOptions = {};
	temp: any = {};
	addressForm: FormGroup = this.formBuilder.group({});
	addressFormElements: any = [];
	states: any = [];
	districts: any = [];
	tehsils: any = [];
	addressData: any = {};
	parliamentaryConsistuencies: any = [];
	@Input() isJssScheme: boolean;
	currentUser:any;
	constructor(
		private formBuilder: FormBuilder,
		private geographiesService: GeographiesService,
		private cdr: ChangeDetectorRef,
		private sharedService: SharedService,
		private currentUserService:CurrentUserService
	) {

		this.addressData = {
			states: [],
			districts: [],
			tehsils: [],
			cities: [],
			parliamentaryConsistuencies: [],
			address: '',
			cityTextBox: '',
			landmark: '',
			multiUpload: false,
			addressProofTypeOptions: ADDRESS_PROOF_TYPE
		};
		this.sharedService.getdynamicErroeEventFired().subscribe(bool => {
			if (bool) {
				this.addressFormElements.forms.filter(res => {
					this.sharedService.markFormGroupTouched(res.formRef);
				});
			}
		});
		// 		 addressProofTypeOptions: [
		// 'Bank Statement',
		// 'Electricity Bill(Not Older than 2 Months)',
		// 'GST Registration',
		// 'Incorporation Certificate',
		// 'Provident Fund Registration Certificate',
		// 'Registration Certificate',
		// 'Rent Agreement + Telephone/Electricity Bill',
		// 'Telephone Bill(BSNL/MTNL Only)',
		// 'MoU/Agreement'
		// 		 ]
		// 	};
		if (this.options.schemeType && this.options.schemeType === 'feeBased') {
			this.addressData.addressProofTypeOptions = ADDRESS_PROOF_TYPE_FEEBASED
			// this.addressData.addressProofTypeOptions = ADDRESS_PROOF_TYPE;
		} else {
			this.addressData.addressProofTypeOptions = ADDRESS_PROOF_TYPE;
			// this.addressData.addressProofTypeOptions = ADDRESS_PROOF_TYPE_FEEBASED
		}
	}

	onCompleteAddressChange(address) {
		this.completeAddress = address;
		this.completeAddressChange.emit(this.completeAddress);
		this.completeAddressChange.emit({
			address: this._value
		});
		if (this.residential==true) {
			Helpers.copyArray(this.addressData.addressProofTypeOptions,ADDRESS_PROOF_TYPE_SMART);
			// this.addressData.addressProofTypeOptions = ADDRESS_PROOF_TYPE_SMART;
		}

	}

	private get _value() {
		const address = Helpers.copyObj(this.completeAddress.address);
		address.state = this.states.find(state => state.name === address.state);
		if (address.state) {
			address.state.id = address.state.code;
		}
		address.district = this.districts.find(
			district => district.name === address.district
		);
		if (address.district) {
			address.district.id = address.district.code;
			if (this.addressData && this.addressData.district && this.addressData.district.districtCategory) {
				address.district.districtCategory = this.addressData.district.districtCategory ? this.addressData.district.districtCategory : ''
			}

		}
		address.tehsil = this.tehsils.find(
			tehsil => tehsil.name === address.tehsil
		);
		if (address.tehsil) {
			address.tehsil.id = address.tehsil.code;
		}
		address.parliamentaryConstituency = this.parliamentaryConsistuencies.find(
			pc => pc.name === address.parliamentaryConstituency
		);
		if (address.parliamentaryConstituency) {
			address.parliamentaryConstituency.id = address.parliamentaryConstituency.no;
		}
		address.city = this.addressData.cities.find(
			city => city.name === address.city
		);
		if (address.city) {
			address.city.id = address.city.code;
		}
		return address;
	}

	private formatOptions() {
		if (this.options.required && this.options.required.parliamentaryConstituency && this.options.required.parliamentaryConstituency === true) {
			this.parliamentary = true;
		}
		this.options = this.options || this.defaultOptions;
		this.options.fields = this.options.fields || this.defaultOptions.fields;
		Object.assign(this.defaultOptions.fields, this.options.fields);
		this.options.required = this.options.required || this.defaultOptions.required;
		Object.assign(this.defaultOptions.required, this.options.required);
		Object.assign(this.defaultOptions.required, FORCED_REQUIREDS_FIELDS);
		Object.assign(this.options.required, FORCED_REQUIREDS_FIELDS);
		Object.assign(this.defaultOptions, this.options);
		this.options = this.defaultOptions;
		this.options.fields.name = this.nameRequired || this.options.nameRequired || this.options.fields.name;
		this.options.fields.addressProof = this.addressProofRequired || this.options.addressProofRequired || this.options.fields.addressProof;
		this.options.fields.addressProofType = this.addressProofTypeRequired ||
			this.options.addressProofTypeRequired ||
			this.options.fields.addressProofType;
		this.defaultAddress = this.completeAddress || this.defaultAddress;
		const inputAddress = {
			label: this.label,
			subLabel: this.subLabel,
			address: this.address || this.defaultAddress.address1,
			landmark: this.landmark || this.defaultAddress.landmark,
			pincode: this.pincode || this.defaultAddress.pincode,
			state: this.state || this.defaultAddress.state,
			district: this.district || this.defaultAddress.district,
			tehsil: this.tehsil || this.defaultAddress.tehsil,
			city: this.city || this.defaultAddress.city,
			cityTextBox: this.cityTextBox || this.defaultAddress.cityTextBox,
			parliamentaryConstituency:
				this.parliamentaryConstituency ||
				this.defaultAddress.parliamentaryConstituency,
			addressProofType: this.addressProofType || this.defaultAddress.addressProofType,
			addressProof: this.addressProof || this.defaultAddress.addressProof,
			geoLocation: this.defaultAddress.geoLocation,
		};
		Object.assign(this.addressData, inputAddress);
		Object.assign(
			this.addressData, this.options
		);
	}

	onGeoLocationChange(location) {
		const pinCode = Helpers.getValueFromObject(location, 'components.postal_code');
		if (pinCode && this.addressFormControl) {
			this.pincode = pinCode.long_name;
			this.addressFormControl.patchValues({
				pincode: this.pincode
			})
		}
	}

	onAddressProofTypeChange(addressProofType) {
		console.log(addressProofType, this.addressData, this.addressFormElements, this.addressFormControl);
		this.addressFormControl.resetFields(['addressProof']);
		// this.addressFormElements.forms[0].formElements.filter((ele) => {
		// 	if (ele.name === "addressProofType") {
		// 		if (this.addressData.addressProofType !== ele.value) {

		// 		}
		// 	}
		// } )
		// this.addressData.addressProof = '';
	}

	ngOnInit() {
		if(this.isJssScheme){
			this.getUserDetails();
		}
		this.formatOptions();
		console.log(this.tcState);
		this.addressFormElements = getAddressElements(
			this.addressData,
			{
				stateChange: this.onStateChange.bind(this),
				districtChange: this.onDistrictChange.bind(this),
				tehsilChange: this.onTehsilChange.bind(this),
				parliamentaryConsistuencyChange: this.onParliamentaryChange.bind(this),
				geoLocationChange: this.onGeoLocationChange.bind(this),
				addressProofTypeChange: this.onAddressProofTypeChange.bind(this)

			},
			// {
			// 	name: this.nameRequired || this.options.nameRequired,
			// 	addressProofTypeRequired: this.addressProofTypeRequired || this.options.addressProofTypeRequired,
			// 	addressProofRequired: this.addressProofRequired || this.options.addressProofRequired
			// },
			this.options.fields,
			this.options.required,
			this.tccaf,
			this.parliamentary
		);
		const addressFormControl = DFormHelpers.forms(this.addressFormElements);
		this.control.emit(addressFormControl);
		if (this.tcState === 'editing') {
			addressFormControl.makeFieldsReadOnly(['state', 'district']);
		}
		if (this.isNorthEastStatesOnly) {
			this.geographiesService.getNorthEastStatesOnly().subscribe(
				({ states }) => {
					states = states || [];
					this.states = states.map(state => {
						state.value = state.name;
						return state;
					});
					this.copyArray(this.addressData.states, this.states);
					this.onStateChange(this.state);
				},
				err => {
					// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
					// this.copyArray(this.addressData.states, fake);
				}
			);
		} else {
			this.geographiesService.getStates().subscribe(
				({ states }) => {
					states = states || [];
					if(this.isJssScheme){
						states = [
							{
								code:this.currentUser?.address?.stateId || '',
								name:this.currentUser?.address?.state || ''
							}
						]
					}
					this.states = states.map(state => {
						state.value = state.name;
						return state;
					});
					this.copyArray(this.addressData.states, this.states);
					this.onStateChange(this.state);
				},
				err => {
					// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
					// this.copyArray(this.addressData.states, fake);
				}
			);

		}
	}

	copyArray(arr1, arr2) {
		Helpers.copyArray(arr1, arr2);
	}

	onStateChange(selectedState) {
		this.state = selectedState;
		Helpers.emptyArray(this.addressData.districts,
			this.districts,
			this.addressData.parliamentaryConsistuencies,
			this.parliamentaryConsistuencies);
		const stateData = this.states.find(state => {
			return state.name === selectedState;
		});
		if (!stateData) {
			return;
		}
		this.stateChange.emit(this.state);
		this.geographiesService.getDistricts(stateData.code).subscribe(
			({ districts }) => {
				districts = districts && districts instanceof Array && districts ? districts : [];
				if(this.isJssScheme){
					districts = districts.filter(dist => dist.name === this.district)
				}
				districts = districts.map(d => {
					d.value = d.name;
					return d;
				});
				this.copyArray(this.districts, districts);
				this.copyArray(this.addressData.districts, districts);
				this.onDistrictChange(this.district);
			},
			err => {
				// console.log(err);
				// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
				// this.copyArray(this.addressData.districts, fake);
			}
		);
		this.geographiesService
			.getParliamentaryConstituenciess(stateData.code)
			.subscribe(
				({ constituencyDetails }) => {
					constituencyDetails = constituencyDetails && constituencyDetails instanceof Array && constituencyDetails ? constituencyDetails : [];
					this.parliamentaryConsistuencies = constituencyDetails;
					this.parliamentaryConsistuencies = this.parliamentaryConsistuencies.map(
						pc => {
							pc.value = pc.name;
							return pc;
						}
					);
					this.copyArray(
						this.addressData.parliamentaryConsistuencies,
						this.parliamentaryConsistuencies
					);
				},
				err => {
					// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
					// this.copyArray(this.addressData.parliamentaryConsistuencies, fake);
					// this.onParliamentaryChange(this.parliamentaryConstituency);
				}
			);
	}

	onDistrictChange(selectedDistrict) {
		Helpers.emptyArray(this.addressData.tehsils);
		// Helpers.emptyArray(this.addressData.tehsils, this.addressData.cities, this.addressData.parliamentaryConsistuencies);
		const districtData = this.districts.find(district => {
			return district.name === selectedDistrict;
		});
		if (!districtData) {
			// Helpers.emptyArray(this.addressData.districts);
			return;
		}
		this.district = selectedDistrict;
		this.districtChange.emit(selectedDistrict);
		this.geographiesService.getTehsil(districtData.code).subscribe(
			({ subDistricts }) => {
				subDistricts = subDistricts && subDistricts instanceof Array && subDistricts || [];
				subDistricts = subDistricts.map(sd => {
					sd.value = sd.name;
					return sd;
				});
				const tehsils = subDistricts;
				this.copyArray(this.tehsils, tehsils);
				this.copyArray(this.addressData.tehsils, tehsils);
				this.onTehsilChange(this.tehsil);
			},
			err => {
				// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
				// this.copyArray(this.addressData.tehsils, fake);
			}
		);
	}

	onAddressChange(address) {
		this.addressChange.emit(address);
	}

	onLandmarkChange(landmark) {
		this.landmarkChange.emit(landmark);
	}

	onPincodeChange(pincode) {
		this.pincodeChange.emit(pincode);
	}

	onTehsilChange(tehsil) {
		Helpers.emptyArray(this.addressData.cities);
		this.tehsilChange.emit(tehsil);
		const tehsilName = tehsil;
		const tehsilData = this.addressData.tehsils.find(t => t.name === tehsilName);
		if (!tehsilData) {
			return;
		}
		this.geographiesService.getVillages(tehsilData.code)
			.subscribe(({ villages }) => {
				villages = (villages && villages instanceof Array && villages) || [];
				const formattedVillages = villages.map(village => (
					{
						name: village.name,
						value: village.name,
						code: village.code,
						id: village.code,
					}
				));
				Helpers.copyArray(this.addressData.cities, formattedVillages);
			});
	}

	onParliamentaryChange(parliamentary) {
		this.parliamentaryChange.emit(parliamentary);
	}

	ngOnChanges() {
		if (this.validationCheck) {
			this.addressFormElements.forms.filter(res => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
		}
	}

	ngDoCheck() {
		this.cdr.markForCheck()
	}

	getUserDetails(){
		this.currentUserService.getCurrentUser().subscribe((res:any)=>{
			this.currentUser = res;
		})
	}
}
